import React, { Fragment, useContext, useEffect, useState } from 'react';
import styles from './thirdPartyQuestionnaireStyles.module.css';
import {
    IThirdPartyQuestionnaireContext, ThirdPartyQuestionnaireContext,
} from "../../../Context/thirdPartyQuestionnaireContext";
import { IQuestionsFromSubCategories, } from "../../../Models/thirdPartyQuestionnarieModels";
import { ValidateAnswerWithRegex } from "../thirdPartyQuestionsToAsk/allQuestionComponents";
import GlobalPopUp from "../../global/globalPopUp/GLobalPopUp";

const ThirdPartyQuestionnaireSubmit = () => {

    const [flagSubmitDisabled, setFlagSubmitDisabled] = useState(true);
    const [flagConfirming, setFlagConfirming] = useState(false);

    const {
        questionsToAsk,
        flagSubmitDisabled: flagDisableFromContext
    } = useContext(ThirdPartyQuestionnaireContext) as IThirdPartyQuestionnaireContext;

    useEffect(() => {
        FlagAllQuestionsAreValid();
    }, [questionsToAsk]);

    const FlagValidAnswer = (question: IQuestionsFromSubCategories) => {
        if(question.answer !== null && question.answer !== "" && question.isRequired) {
            if(question.questionRegex === null) return true;
            return ValidateAnswerWithRegex(question.questionRegex, question.answer);
        }
        else if((question.answer === null || question.answer === "") && !question.isRequired) return true;
        return false;
    }

    const FlagAllQuestionsAreValid = () => {
        let flagFoundInvalidAnswer = false;

        for(let i=0; i<questionsToAsk.length; i++) {
            const section = questionsToAsk[i];
            for(let j=0; j<section.subCategories.length; j++) {
                const subSection = section.subCategories[j];
                for(let k=0; k<subSection.questions.length; k++) {
                    const question = subSection.questions[k];
                    if(!FlagValidAnswer(question)) {
                        flagFoundInvalidAnswer = true;
                        break;
                    }
                }
            }
        }

        if(!flagFoundInvalidAnswer) setFlagSubmitDisabled(false);
        else setFlagSubmitDisabled(true);
    }

    const CheckForSubmit = () => {
        setFlagConfirming(true);
    }

    return (
        <Fragment>
            <GlobalPopUp setflagPopUp={setFlagConfirming} flagPopUp={flagConfirming} heading={"Are you sure you want to submit?"} section={"confirmSubmit"} />
            <button
                className={styles.submit_btn}
                disabled={(flagSubmitDisabled || flagDisableFromContext)}
                onClick={CheckForSubmit}
            >
                Submit
            </button>
        </Fragment>
    );
};

export default ThirdPartyQuestionnaireSubmit;

